// extracted by mini-css-extract-plugin
export default {"p1":"P1_p1__fi47+","bold":"P1_bold__-qvZ5"};